import {
  resolveRatingLabel,
  RatingLabelResult,
} from '../../utils/resolve-rating-label'

export class CheckinSkillLevelLabelVm {
  private resolved: RatingLabelResult

  constructor(
    level: number | null,
    statusLabel?: string | null,
    statusColor?: string | null
  ) {
    // Treat as not_checked_in when: level is absent, OR level is set but the
    // rating scale couldn't resolve a color (null = explicitly out of range).
    const status =
      level == null || statusColor === null ? 'not_checked_in' : undefined
    this.resolved = resolveRatingLabel({ status, statusLabel, statusColor })
  }

  get ratingColor(): string | null {
    return this.resolved.color
  }

  get text(): string | undefined {
    return this.resolved.text
  }
}
